/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2024-12-04 10:11:07
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-05-27 20:31:19
 * @FilePath: \vue-template\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import axios from "axios";
import "vant/lib/index.css";
import "@/static/font/font.css"; //引入字体文件
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
import {
  Tabbar,
  TabbarItem,
  Button,
  Swipe,
  SwipeItem,
  Picker,
  Popup,
  Area,
  NavBar,
  Form,
  Field,
  SubmitBar,
  Toast,
  List,
  Icon,
  CountDown,
  Dialog,
  Empty,
  Loading,
  Checkbox,
  CheckboxGroup,
  Badge,
  Tabs,
  Tab,
  Divider,
  TreeSelect,
  Cascader,
} from "vant";

Vue.use(Cascader);
Vue.use(TreeSelect);
Vue.use(Divider);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Badge);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(CountDown);
Vue.use(Icon);
Vue.use(List);
Vue.use(Toast);
Vue.use(SubmitBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
